import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'

export default class BookingNotFoundRoute extends Route {
  @service router: RouterService
  @service flowManager: FlowManager

  beforeModel() {
    // if we're here it means an invalid route was accessed
    // just go back to the start of the flow
    this.flowManager.goToPage('FlowConfigBookingStartPage')
  }
}

